<template>
    <div class="sticky-top">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid justify-content-end">
                <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul class="navbar-nav">
                        <a class="nav-link active" aria-current="page" href="#">
                            {{ dataTopNavbar[0]?.name }} {{ currentTime }}
                        </a>
                        <li v-for="item in (Array.isArray(dataTopNavbar) ? dataTopNavbar.slice(1) : [])"
                            :key="item.id" class="nav-item">
                            <a v-if="item.url" class="nav-link" :href="item.url" target="_blank">{{ item.name }}</a>
                            <span v-else class="nav-link">{{ item.name }}</span>
                        </li>
                        <li class="nav-item" @mouseenter="toggleDropdown" @mouseleave="closeDropdown">
                            <div class="dropdown">
                                <button class="btn btn-light dropdown-toggle" type="button" @click="toggleDropdown">
                                    <img :src="selectedLanguageFlag" width="20" class="me-1 align-middle"/>
                                    <span class="align-middle">{{ selectedLanguage.toUpperCase() }}</span>
                                </button>
                                <div v-show="showLanguages" class="dropdown-menu show">
                                    <a class="dropdown-item" href="#"
                                       @click.prevent="changeLanguage('uz')"
                                       :class="{ 'active bg-secondary text-light rounded': isActive('uz') }">
                                        <img src="/images/uz.png" width="20" class="me-1 align-middle"/>
                                        <span class="align-middle">UZ</span>
                                    </a>
                                    <a class="dropdown-item" href="#"
                                       @click.prevent="changeLanguage('en')"
                                       :class="{ 'active bg-secondary text-light rounded': isActive('en') }">
                                        <img src="/images/en.png" width="20" class="me-1 align-middle"/>
                                        <span class="align-middle">EN</span>
                                    </a>
                                    <a class="dropdown-item" href="#"
                                       @click.prevent="changeLanguage('ru')"
                                       :class="{ 'active bg-secondary text-light rounded': isActive('ru') }">
                                        <img src="/images/ru.png" width="20" class="me-1 align-middle"/>
                                        <span class="align-middle">RU</span>
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import api from "@/api";

export default {
    name: 'TopNavbar',
    data() {
        return {
            selectedLanguage: localStorage.getItem('language') || 'uz',
            showLanguages: false,
            currentTime: this.getFormattedTime(),
            loading: true,
            dataTopNavbar: {},
            language: localStorage.getItem('language') || 'uz',
        };
    },
    computed: {
        selectedLanguageFlag() {
            const flags = {
                uz: '/images/uz.png',
                en: '/images/en.png',
                ru: '/images/ru.png',
            };
            return flags[this.selectedLanguage] || '/images/uz.png';
        },
    },
    methods: {
        getFormattedTime() {
            return new Date().toLocaleTimeString("en-GB");
        },
        changeLanguage(lang) {
            this.selectedLanguage = lang;
            this.showLanguages = false;
            localStorage.setItem('language', lang);
            this.language = lang;
            this.fetchTopNavbar();
            this.$emit('languageChanged', this.selectedLanguage);
        },
        toggleDropdown() {
            this.showLanguages = !this.showLanguages;
        },
        closeDropdown() {
            this.showLanguages = false;
        },
        isActive(lang) {
            return this.selectedLanguage === lang;
        },
        updateTime() {
            this.currentTime = this.getFormattedTime();
        },
        async fetchTopNavbar() {
            this.loading = true;
            try {
                const {data} = await api.get(`/top-navbar/`, {
                    headers: {'Accept-Language': this.language},
                });
                this.dataTopNavbar = data;
            } catch (error) {
                // xatolikni e’tiborsiz qoldiramiz
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetchTopNavbar();
        this.timer = setInterval(this.updateTime, 1000);
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
.dropdown {
    position: relative;
    display: inline-block;
}

.btn-light {
    border-color: transparent;
    background: transparent;
    box-shadow: none;
    cursor: pointer;
    padding: 0.375rem 0.75rem;
}

.dropdown-toggle {
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    margin: 0.125rem 0 0;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    display: none;
    z-index: 1000;
}

.dropdown-menu.show {
    display: block;
}

.dropdown-item {
    cursor: pointer;
    padding: 0.375rem 0.75rem;
}

.dropdown-item:hover {
    background-color: #e9ecef;
}
</style>
